/* eslint-disable */
import { push } from 'redux-router';


export function openOverlay(name) {
    return (dispatch, getState) => {
        const router = getState().router;
        const newQuery = {
            ...router.location.query,
            overlay: name,
        };

        dispatch(push({
            pathname: router.location.pathname,
            query: newQuery,
        }));
    };
}

export function closeOverlay() {
    return (dispatch, getState) => {
        const router = getState().router;
        const newQuery = { ...router.location.query };
        delete newQuery.overlay;

        dispatch(push({
            pathname: router.location.pathname,
            query: newQuery,
        }));
    };
}
